import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, ToastProvider } from './contexts';
import { ProtectedRoute, Layout } from './components';
import {
  LandingPage,
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  UnauthorizedPage,
  DashboardPage,
  AdminPage,
  ProfilePage,
  PropertyPage,
  PropertiesPage,
  EditPropertyPage,
  CreatePropertyPage,
  WelcomePage,
} from './pages';
import './App.css';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Layout>
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                  path="/forgot-password"
                  element={<ForgotPasswordPage />}
                />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />

                {/* Protected routes - require authentication */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/welcome"
                  element={
                    <ProtectedRoute>
                      <WelcomePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/properties"
                  element={
                    <ProtectedRoute>
                      <PropertiesPage />
                    </ProtectedRoute>
                  }
                />

                {/* Property routes */}
                <Route
                  path="/properties/new"
                  element={
                    <ProtectedRoute>
                      <CreatePropertyPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/properties/:id/edit"
                  element={
                    <ProtectedRoute>
                      <EditPropertyPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/properties/:id"
                  element={
                    <ProtectedRoute>
                      <PropertyPage />
                    </ProtectedRoute>
                  }
                />

                {/* Admin-only routes - require admin role */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
